import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ThemeService } from '../../../../src/app/core/services/theme.service';

@Component({
    selector: 'alta-header',
    standalone: true,
    imports: [CommonModule, RouterLink, RouterLinkActive],
    templateUrl: './alta.header.componente.html',
    styleUrls: ['./alta.header.componente.scss']
})
export class SdsHeaderComponent {
    private themeService = inject(ThemeService);
    mobileMenuOpen = false;

    // Signal computado para a logo
    logoSrc = computed(() => {
        const theme = this.themeService.theme;
        return theme === 'dark'
            ? '/assets/brand/ALTA_SISTEMAS/SVG/logo-white.svg'
            : '/assets/brand/ALTA_SISTEMAS/SVG/logo-black.svg';
    });

    constructor() { }

    get currentTheme() {
        return this.themeService.theme;
    }

    toggleMobileMenu(): void {
        this.mobileMenuOpen = !this.mobileMenuOpen;
    }

    closeMobileMenu(): void {
        this.mobileMenuOpen = false;
    }

    toggleTheme(): void {
        this.themeService.toggleTheme();
    }

    scrollToSection(event: Event, sectionId: string): void {
        event.preventDefault();
        this.closeMobileMenu();
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
            // Se não encontrar a seção, navega para home com fragmento
            window.location.href = '/#' + sectionId;
        }
    }
}
